import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';
import cx from 'classnames';

import Icon, { GLYPHS } from './icon';

const Modal = ({
  children,
  close,
  title,
  showCloseButton,
  shouldCloseOnOverlayClick,
  showHeader,
  BackButton,
  showSwitcher,
  switcherId,
  onChange,
  disabled,
  checked,
  barberName,
  className,
  overlayClassName,
  headerClassName,
  bodyClassName,
  automationIdPart,
}) => {
  const mainBaseClassName = cx(
    'c-modal remodal remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
    className
  );
  const overlayBaseClassName = cx(
    's-v2 remodal-overlay remodal-wrapper remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
    overlayClassName
  );

  return (
    <ReactModal
      className={{
        base: mainBaseClassName,
        afterOpen: 'remodal-is-opened',
        beforeClose: 'remodal-is-closing',
      }}
      overlayClassName={{
        base: overlayBaseClassName,
        afterOpen: 'remodal-is-opened',
        beforeClose: 'remodal-is-closing',
      }}
      closeTimeoutMS={150}
      onRequestClose={close}
      contentLabel="Modal"
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      isOpen
      ariaHideApp={false}
    >
      <div
        className={cx('c-modal__header', headerClassName)}
        display-if={showHeader}
        data-automation-id={`text:${automationIdPart}:title`}
      >
        <div className="c-modal__back-button" display-if={BackButton}>
          <BackButton />
        </div>
        <div className="c-modal__controls" display-if={showCloseButton}>
          <button
            className="c-btn c-btn--blank"
            type="button"
            onClick={close}
            data-automation-id={`button:${automationIdPart}:close`}
          >
            <Icon glyph={GLYPHS.close} />
          </button>
        </div>
        <div className="u-text-left u--ml u-pl" display-if={showSwitcher}>
          <div className="c-switch u-inline-block u-align-middle u-mr">
            <input
              id={switcherId}
              className="c-switch__toggle"
              type="checkbox"
              onChange={e => onChange(e.target.checked)}
              disabled={disabled}
              checked={checked}
            />
            <label className="c-switch__label" htmlFor={switcherId} />
          </div>
          <div className="c-heading u-inline-block u-type--capitalize u-type--normal">{barberName}</div>
        </div>
        {title}
      </div>
      <div className={cx('c-modal__body', bodyClassName)}>{children}</div>
    </ReactModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  close: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showCloseButton: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  showHeader: PropTypes.bool,
  BackButton: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  showSwitcher: PropTypes.bool,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  switcherId: PropTypes.string, // eslint-disable-line
  onChange: PropTypes.func,
  barberName: PropTypes.string, // eslint-disable-line
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  automationIdPart: PropTypes.string,
};

Modal.defaultProps = {
  showCloseButton: false,
  shouldCloseOnOverlayClick: true,
  showHeader: true,
  title: '',
  BackButton: null,
  showSwitcher: false,
  checked: false,
  disabled: false,
  onChange: () => null,
  className: '',
  overlayClassName: '',
  bodyClassName: '',
  headerClassName: '',
  automationIdPart: null,
};

export default Modal;
